import apiClient from './apiClient';

// Configuration responses can describe credentials and bootstrap controls. Keep
// arbitrary backend text out of the rendered UI and retain only stable metadata
// that the page maps to localized, non-sensitive messages.
const handleError = (error) => {
  const formatted = new Error('Configuration request failed');
  formatted.code =
    error.response?.data?.error?.code ||
    error.response?.data?.code ||
    error.code ||
    'CONFIGURATION_REQUEST_FAILED';
  formatted.status = error.response?.status || null;
  formatted.requestId =
    error.response?.data?.error?.details?.requestId ||
    error.response?.headers?.['x-request-id'] ||
    null;
  return formatted;
};

const configurationService = {
  // The backend is the catalog authority. This keeps the UI complete when a
  // setting is added and avoids a second, inevitably drifting frontend list.
  getConfiguration: async () => {
    try {
      const response = await apiClient.get('/admin/configuration');
      return response.data.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Changes are optimistic-concurrency protected by the catalog revision.
  // Secret replacements are sent only in this request and are never returned.
  updateConfiguration: async ({ revision, changes }) => {
    try {
      const response = await apiClient.put('/admin/configuration', { revision, changes });
      return response.data.data;
    } catch (error) {
      throw handleError(error);
    }
  },
};

export default configurationService;
